import { Component, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';

import { AddressAddressee } from '../../../models';
import { BaseComponent, BaseEditFormModalComponent } from '../../../../tms-shared';
import { AddressAddresseeService } from '../../../services/edit-create/address/address-addressee.service';
import { AddressService } from '../../../services/edit-create/address/address.service';
import { TmsFormlyService } from '../../../services/formly/tms-formly.service';

@Component({
  selector: 'app-address-create-addressees-modal',
  templateUrl: './address-create-addressees-modal.component.html',
  styleUrl: './address-create-addressees-modal.component.scss',
})
export class AddressCreateAddresseesModalComponent extends BaseComponent implements OnInit {
  @ViewChild(BaseEditFormModalComponent) form: BaseEditFormModalComponent;
  @Input() id: string;
  @Input() addressId: string;

  @Output() newAddressee: AddressAddressee;

  fields: FormlyFieldConfig[];

  constructor(
    public addressAddresseeService: AddressAddresseeService,
    private addressService: AddressService,
    private formlyService: TmsFormlyService,
  ) {
    super();
  }

  ngOnInit() {
    this.getFields();
  }

  private getFields() {
    this.fields = [this.formlyService.text('addressee', $localize`Addressee`, undefined, { required: true })];
  }

  saved(model: AddressAddressee) {
    this.newAddressee = model;
    this.addressService.refreshDetails.next();
  }
}
